import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  InternalApiCustomListMonitoringField,
  InternalApiCustomListSchemaField,
  InternalApiCustomListScreeningField,
} from '../api-internal';

export interface CustomListState {
  id: string;
  schemaFields: InternalApiCustomListSchemaField[];
  usableScreeningFields: InternalApiCustomListScreeningField[];
  usableMonitoringFields: InternalApiCustomListMonitoringField[];
}

const initialState: CustomListState = {
  id: '',
  schemaFields: [],
  usableScreeningFields: [],
  usableMonitoringFields: [],
};

const customListSlice = createSlice({
  name: 'custom-list',
  initialState,
  reducers: {
    fetchCustomListSchemaSuccess: (state, action: PayloadAction<Array<InternalApiCustomListSchemaField>>) => {
      return {
        ...state,
        schemaFields: action.payload.sort((a, b) => a.sortOrder - b.sortOrder),
      };
    },
    fetchUsableScreeningFieldsSuccess: (state, action: PayloadAction<Array<InternalApiCustomListScreeningField>>) => {
      return {
        ...state,
        usableScreeningFields: action.payload,
      };
    },
    fetchUsableMonitoringFieldsSuccess: (state, action: PayloadAction<Array<InternalApiCustomListMonitoringField>>) => {
      return {
        ...state,
        usableMonitoringFields: action.payload,
      };
    },
    addUsableScreeningFieldsSuccess: (state, action: PayloadAction<Array<InternalApiCustomListScreeningField>>) => {
      return {
        ...state,
        usableScreeningFields: state.usableScreeningFields.concat(action.payload),
      };
    },
    addUsableMonitoringFieldsSuccess: (state, action: PayloadAction<Array<InternalApiCustomListMonitoringField>>) => {
      return {
        ...state,
        usableMonitoringFields: state.usableMonitoringFields.concat(action.payload),
      };
    },
  },
});

const { actions, reducer } = customListSlice;
export const {
  fetchCustomListSchemaSuccess,
  fetchUsableScreeningFieldsSuccess,
  fetchUsableMonitoringFieldsSuccess,
  addUsableScreeningFieldsSuccess,
  addUsableMonitoringFieldsSuccess,
} = actions;
export default reducer;
